<template>
  <section class="submit-draft">
    <base-container>
      <div class="inner-container">
        <h3 class="title">1.填寫草稿</h3>
        <el-card class="box-card">
          <div class="form">
            <el-form
              label-position="top"
              ref="draftRule"
              :model="draftRule"
              :rules="rules"
            >
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="姓氏" prop="lastName">
                    <el-input
                      type="primary"
                      id="lastName"
                      placeholder="Last Name"
                      v-model.trim="draftRule.lastName"
                    ></el-input>
                  </el-form-item>
                  <!-- <label for="lastName">姓氏</label>
                <el-input
                  type="primary"
                  id="lastName"
                  placeholder="Last Name"
                ></el-input> -->
                </el-col>
                <el-col :span="12">
                  <!-- <label for="firstName">名字</label> -->
                  <el-form-item label="名字" prop="firstName">
                    <el-input
                      type="primary"
                      id="firstName"
                      placeholder="First Name"
                      v-model.trim="draftRule.firstName"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="電郵地址" prop="email">
                    <el-input
                      type="primary"
                      id="email"
                      placeholder="Email"
                      v-model.trim="draftRule.email"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="聯絡電話" prop="contactNumber">
                    <el-input
                      type="primary"
                      id="contactNumber"
                      placeholder="Contact Number"
                      v-model.number="draftRule.contactNumber"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item
                    class="radio inline-label"
                    label="額外保障"
                    prop="shipment"
                  >
                    <!-- <el-radio-group v-model="draftRule.shipment"> -->
                    <el-radio v-model="draftRule.shipment" label="1" border>
                      <p>Standard（免費）</p>
                      <p>賠償額50% 最高賠償港幣 $800</p>
                    </el-radio>
                    <!-- </el-radio-group> -->
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item class="radio" style="margin-top: 2.63rem">
                    <el-radio v-model="draftRule.shipment" label="2" border>
                      <p>Basic（每張訂單只需HK$20））</p>
                      <p>賠償額50% 最高賠償港幣 $10,000</p>
                    </el-radio>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item class="radio">
                    <!-- <el-radio-group v-model="draftRule.shipment"> -->
                    <el-radio v-model="draftRule.shipment" label="3" border>
                      <p>Plus（整張訂單貨品價錢的2.5%）</p>
                      <p>賠償額80% 最高賠償港幣 $50,000</p>
                    </el-radio>
                    <!-- </el-radio-group> -->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item class="radio">
                    <!-- <el-radio-group v-model="draftRule.shipment"> -->
                    <el-radio v-model="draftRule.shipment" label="4" border>
                      <p>Super Care（整張訂單貨品價錢的3%）</p>
                      <p>賠償額100% 最高賠償港幣 $100,000</p>
                    </el-radio>
                    <!-- </el-radio-group> -->
                  </el-form-item>
                </el-col>
              </el-row>

              <submit-draft-options></submit-draft-options>
            </el-form>
          </div>
        </el-card>
      </div>
    </base-container>
  </section>
</template>

<script>
import SubmitDraftOptions from "./SubmitDraftOptions.vue";

export default {
  components: {
    SubmitDraftOptions,
  },
  data() {
    return {
      draftRule: {
        firstName: "",
        lastName: "",
        email: "",
        shipment: "",
        contactNumber: null,
      },
      rules: {
        firstName: [
          {
            required: true,
            message: "First Name is required!",
            trigger: "blur",
          },
        ],
        lastName: [
          {
            required: true,
            message: "Last Name is required!",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "Email is required!",
            trigger: "blur",
          },
          {
            type: "email",
          },
        ],
        contactNumber: [
          {
            required: true,
            message: "Contact Number is requried!",
            trigger: "blur",
          },
          {
            type: "number",
          },
        ],
        shipment: [
          {
            required: true,
            message: "Please Select Shipment method",
            trigger: "change",
          },
        ],
      },
    };
  },
};
</script>

<style>
.submit-draft .inner-container {
  padding: 0 5rem;
}

.submit-draft .title {
  color: #7a3d87;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  font-weight: 700;
  padding: 4rem 0 2rem 0;
}

.submit-draft .box-card {
  margin-top: 2rem;
  border-radius: 8px;
}

.submit-draft .form {
  padding: 1rem 2rem;
}

.submit-draft .el-input__inner {
  border-radius: 8px;
}

.submit-draft .el-form-item__label {
  padding: 0 !important;
}

.submit-draft .radio .el-form-item__content {
  line-height: 20px;
}

.submit-draft .el-radio {
  padding: 2.5rem 0 2.5rem 1rem !important;
  width: 100%;
  border-radius: 8px !important;
}

.submit-draft .el-radio p:first-of-type {
  color: #7a3d87;
  font-weight: 700;
}

.submit-draft .el-radio.is-checked {
  background-color: #7a3d87;
  border-color: #7a3d87 !important;
}

.submit-draft .el-radio.is-checked p:nth-of-type(1) {
  color: #fff;
}

.submit-draft .el-radio.is-checked p:nth-of-type(2) {
  color: #f5f5f5;
}

.submit-draft .el-radio__input.is-checked + .el-radio__label {
  color: #fff;
}

.submit-draft .el-radio__input.is-checked .el-radio__inner {
  background-color: #7a3d87;
  border-color: #fff;
}

.submit-draft .el-radio__input.is-checked .el-radio__inner::after {
  width: 7px;
  height: 7px;
  border-radius: 100%;
}

/* .submit-draft .el-form-item__label {
  display: inline !important;
} */

/* .submit-draft .inline-label .el-form-item__label:after {
  content: "Repack與額外保障服務不能同時使用";
  color: #f65252;
  font-size: 12px;
  margin-left: 0.5rem;
} */
</style>